import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {TranslationMessage} from '../../../../../models/translation/translation-message';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslationMessageService} from '../../../../../services/translation-message/translation-message.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {LoaderService} from '../../../../../services/loader/loader.service';

@Component({
  selector: 'app-translation-error-form',
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './translation-error-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-error-form.component.scss',
})
export class TranslationErrorFormComponent implements Dialog {
  message: TranslationMessage | null = null;
  text: string = '';
  line: number | null = null;
  column: number | null = null;
  error: string | null = null;
  position: any | null = null;

  constructor(
    private translationMessageService: TranslationMessageService,
    private dialogService: DialogService,
    private loader: LoaderService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.class = 'modal-lg';

    this.message = params.data;
    this.text = this.message?.text ?? '';
    this.line = this.message?.error?.line ?? null;
    this.column = this.message?.error?.column ?? null;
    this.error = this.message?.error?.message ?? null;
  }

  getCursorPosition(textarea: any): any {
    const pos = textarea.selectionStart;
    const text = textarea.value.substring(0, pos);

    const lines = text.split('\n');

    return {
      line: lines.length,                     // Commence à 1
      column: lines[lines.length - 1].length + 1 // Commence à 1
    };
  }

  updatePosition(e: Event): void {
    this.position = this.getCursorPosition(e.target);
  }

  submit(): void {
    if (this.message && this.message.domain?.id && this.message.locale && this.message.key) {
      this.loader.startLoading();

      this.message.text = this.text;

      this.translationMessageService.writeMessage(
        this.message.domain.id,
        this.message.locale,
        this.message.key,
        this.message.text
      ).subscribe(() => {
        this.dialogService.closeDialog(true);
        this.loader.stopLoading();
      });
    }
  }
}
